import React from 'react';
import { Button } from '../../../../../base/components/Button';
import { Icon } from '../../../../../base/components/Icon';
import { Modal } from '../../../../../base/components/Modal';
import { useAppDispatch } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { vacancyListActions } from '../../redux/slices/vacancyListSlice';
import { vacancyActions } from '../../redux/slices/vacancySlice';

import './styles.scss';

interface Props {
    vacancyId: string;
    visible: boolean;
    visibilityHandler: () => void;
    actionAfterSubmit: 'reload' | 'redirect';
}

export const CloseVacancyModal = ({ vacancyId, visible, visibilityHandler, actionAfterSubmit }: Props) => {
    const dispatch = useAppDispatch();

    const submitVacancyClose = () => {
        if (actionAfterSubmit === 'redirect') {
            dispatch(vacancyActions.closeVacancyRequest(vacancyId));
        }
        if (actionAfterSubmit === 'reload') {
            dispatch(vacancyListActions.closeVacancyRequest(vacancyId));
        }

        visibilityHandler();
    };

    return (
        <Modal visible={visible} visibilityHandler={visibilityHandler} className='close-vacancy-modal'>
            <Icon icon='circle-exclamation-light' className='close-vacancy-modal__icon' color='danger' size='60px' />
            <p className='close-vacancy-modal__text'>
                {__t('Закрытые вакансии не видны работникам. Все полученные отклики остаются в этой вакансии.')}
            </p>
            <p className='close-vacancy-modal__text'>
                {__t('Вы всегда сможете открыть вакансию, если она станет актуальной.')}
            </p>
            <div className='close-vacancy-modal__buttons'>
                <Button type='secondary' onClick={visibilityHandler} className='close-vacancy-modal__button'>
                    {__t('Отмена')}
                </Button>
                <Button type='primary' onClick={submitVacancyClose} className='close-vacancy-modal__button'>
                    {__t('Закрыть вакансию')}
                </Button>
            </div>
        </Modal>
    );
};
